<template>
  <div class="container">
    <!-- Page Heading -->
    <div class="row">
      <div class="col-lg-12 portfolio-item">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title"><icon name="star" scale="1.5" /> Featured Datasets <a class="view-all" target="_blank" href="https://data.world">[view all]</a></h4>
            <carousel :perPage="4" :navigationEnabled="true" :paginationEnabled="false" :perPageCustom="[[0, 2], [800, 4]]" :navigationClickTargetSize="0" :navigationPrevLabel="'\uf0a8'" :navigationNextLabel="'\uf0a9'">
              <slide class="" v-for="(fds, index) in sorted_featured_datasets">
                <div class="card-body">
                  <h4 class="card-title">
                  <a :href="fds.dataset_url" target="_blank">{{fds.week}}</a>
                </h4>
                  <p class="card-text">{{fds.topic}}</p>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 portfolio-item">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">
              <icon name="clock" scale="1.5" /> Recent Integrations<br><a class="view-all" target="_blank" href="https://data.world">[view all]</a>
            </h4>
            <p class="card-text" v-for="(fri, index) in filtered_recent_integrations"><a :href="fri.URL" target="_blank">{{fri.name}}</a></p>
          </div>
        </div>
      </div>
      <div class="col-lg-9 col-md-8 col-sm-12 portfolio-item hidden-md-down">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">
                <icon name="tag" scale="1.5" /> Tag Cloud <a class="view-all" target="_blank" href="https://data.world">[view all]</a>
              </h4>
            <VueTagCloud v-bind:data="tag_cloud" v-if="tag_cloud.length > 10"></VueTagCloud>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 portfolio-item">
        <div class="card h-100">
          <div class="card-body">
            <h4 class="card-title">
            <icon name="handshake" scale="1.5" /> Recent Data Partners <a class="view-all" target="_blank" href="https://data.world">[view all]</a>
              </h4>
            <p class="card-text" v-for="(frdp, index) in filtered_recent_data_partners"><a :href="frdp.URL" target="_blank">{{frdp.name}}</a>
              <br>({{frdp.dataset_count || 0}} datasets)</p>
          </div>
        </div>
      </div>
      <div class="col-lg-9 col-md-8 col-sm-9 portfolio-item">
        <div class="card h-100">
          <div class="card-body">
            <div class="text-center">
              <select v-model="selected" class="select">
                <option>Popular</option>
                <option>New</option>
                <option>Rising</option>
              </select>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-5 col-sm-5 bordered">
                <h4 class="card-title">
                <icon name="table" scale="1.5" /> Datasets <a class="view-all" target="_blank" href="https://data.world">[view all]</a>
              </h4>
                <transition name="fade">
                  <div v-if="selected === 'Popular'"><p class="card-text" v-for="(fdp, index) in filtered_datasets_popular"><a :href="'https://data.world/' + fdp.owner + '/' + fdp.datasetid" target="_blank">{{fdp.owner}}</a> ({{fdp.views}} views)</p></div>
                </transition>
                <transition name="fade">
                  <div v-if="selected === 'New'"><p class="card-text" v-for="(fdn, index) in filtered_datasets_new"><a :href="fdn.URL" target="_blank">{{fdn.name}}</a></p></div>
                </transition>
                <transition name="fade">
                  <div v-if="selected === 'Rising'"><p class="card-text" v-for="(fdr, index) in filtered_datasets_rising"><a :href="'https://data.world/' + fdr.owner + '/' + fdr.datasetid" target="_blank">{{fdr.owner}}</a> ({{fdr.views}} views)</p></div>
                </transition>
              </div>
              <div class="col-lg-6 col-md-5 col-sm-3">
                <h4 class="card-title">
                <icon name="user" scale="1.5" /> Users <a class="view-all" target="_blank" href="https://data.world">[view all]</a>
              </h4>
                <transition name="fade">
                  <div v-if="selected === 'Popular'"><p class="card-text" v-for="(fup, index) in filtered_users_popular"><a :href="'https://data.world/' + fup.following" target="_blank">{{fup.following}}</a> ({{fup.count}} following)</p></div>
                </transition>
                <transition name="fade">
                  <div v-if="selected === 'New'"><p class="card-text" v-for="(fun, index) in filtered_users_new"><a :href="'https://data.world/' + fun.agentid" target="_blank">{{fun.displayname}}</a></p></div>
                </transition>
                <transition name="fade">
                  <div v-if="selected === 'Rising'"><p class="card-text" v-for="(fur, index) in filtered_users_rising"><a :href="'https://data.world/' + fur.following" target="_blank">{{fur.following}}</a> ({{fur.count}} following)</p></div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.row -->
    <p class="version">Version 0.0.29, 101618|20.51.10</p>
  </div>
</template>
<script>
import VueTagCloud from 'vue-tag-cloud'
import _ from 'lodash'
import moment from 'moment'
import {
  FEATURED_DATASETS,
  RECENT_INTEGRATIONS,
  TAG_CLOUD,
  RECENT_DATA_PARTNERS,
  DATASETS_POPULAR,
  DATASETS_NEW,
  DATASETS_RISING,
  USERS_POPULAR,
  USERS_NEW,
  USERS_RISING
} from '../store'

export default {
  name: 'dwhome',
  components: {},
  data() {
    return {
      selected: 'Popular',
      loading: false,
      featured_datasets: [],
      recent_integrations: [],
      tag_cloud: [],
      recent_data_partners: {},
      datasets_popular: {},
      datasets_new: {},
      datasets_rising: {},
      users_popular: {},
      users_new: {},
      users_rising: {},
      slide: 0,
      sliding: null,
      tagData: [
        { text: "Lorem", weight: 15, link: "https://google.com" },
        { text: "Ipsum", weight: 9 },
        { text: "Dolor", weight: 6 },
        { text: "Sit", weight: 7 },
        { text: "Amet", weight: 5 }
      ]
    }
  },
  mounted: function() {
    this.get()
  },
  components: {
    VueTagCloud
  },
  computed: {
    sorted_featured_datasets: function() {
      //_.sortBy()
      return this.featured_datasets
    },
    filtered_recent_integrations: function() {
      if (this.recent_integrations && this.recent_integrations.length) {
        return this.recent_integrations.slice(0, 10)
      } else {
        return []
      }
    },
    filtered_recent_data_partners: function() {
      if (this.recent_data_partners && this.recent_data_partners.length) {
        return this.recent_data_partners.slice(0, 5)
      } else {
        return []
      }
    },
    filtered_datasets_popular: function() {
      if (this.datasets_popular && this.datasets_popular.length) {
        return this.datasets_popular.slice(0, 10)
      } else {
        return []
      }
    },
    filtered_datasets_new: function() {
      if (this.datasets_new && this.datasets_new.length) {
        return this.datasets_new.slice(0, 7)
      } else {
        return []
      }
    },
    filtered_datasets_rising: function() {
      if (this.datasets_rising && this.datasets_rising.length) {
        return this.datasets_rising.slice(0, 10)
      } else {
        return []
      }
    },
    filtered_users_popular: function() {
      if (this.users_popular && this.users_popular.length) {
        return this.users_popular.slice(0, 10)
      } else {
        return []
      }
    },
    filtered_users_new: function() {
      if (this.users_new && this.users_new.length) {
        return this.users_new.slice(0, 10)
      } else {
        return []
      }
    },
    filtered_users_rising: function() {
      if (this.users_rising && this.users_rising.length) {
        return this.users_rising.slice(0, 10)
      } else {
        return []
      }
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    get() {
      this.loading = true
      this.$http.get(FEATURED_DATASETS, { emulateJSON: true }).then(response => {
        this.featured_datasets = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(RECENT_INTEGRATIONS, { emulateJSON: true }).then(response => {
        this.recent_integrations = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(TAG_CLOUD, { emulateJSON: true }).then(response => {
        this.tag_cloud = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(RECENT_DATA_PARTNERS, { emulateJSON: true }).then(response => {
        this.recent_data_partners = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(DATASETS_POPULAR, { emulateJSON: true }).then(response => {
        this.datasets_popular = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(DATASETS_NEW, { emulateJSON: true }).then(response => {
        this.datasets_new = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(DATASETS_RISING, { emulateJSON: true }).then(response => {
        this.datasets_rising = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(USERS_POPULAR, { emulateJSON: true }).then(response => {
        this.users_popular = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(USERS_NEW, { emulateJSON: true }).then(response => {
        this.users_new = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })

      this.$http.get(USERS_RISING, { emulateJSON: true }).then(response => {
        this.users_rising = response.body
        // localStorage.setItem('kmat_list', JSON.stringify(this.kmat_list))
        this.loading = false
      }, response => {
        // error callback
      })
    }
  }

}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Lato');

h1, h2, h3, h4, h5, div, p {
  font-family: 'Lato', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h4 {
  .view-all {
    font-size: 12px;
  }
}

.VueCarousel-navigation--disabled {
  display: none;
}

.VueCarousel-wrapper {
  height: 250px;
}

.logo {
  height: 25px;
}

.bg-dark {
  background-color: #333d49;
}

a {
  color: #6290c3;
}

a:focus, a:hover {
  color: #3c6a9d;
  text-decoration: none;
}

.navbar {
  padding: 0;
}

.navbar-brand {
  em {
    font-size: 12px;
    color: #ccc;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.8s;
}

.fade-enter-active {
  height: 0px;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  height: 0px;
}

.version {
  position: fixed;
  color: #AAA;
  font-size: 10px;
  right: 25px;
  bottom: -15px;
  z-index: 1000;
}

.select {
  font-size: 18px;
  width: 150px;
  margin-bottom: 12px;
}

h4 {
  font-weight: 700;
}

button {
  font-family: 'FontAwesome' !important;
  font-size: 18px;
}

.bordered {
  border-right: 1px solid rgba(0, 0, 0, 0.125);
}

.py-5 {
  padding:  0 !important;
  position: fixed;
  bottom:  0;
  width: 100%;
}

.copyright {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// dwhome.vue?37d86b50